module.exports = __webpack_public_path__ + "static/media/poin.44aa57a2.png";